import React from "react";
import { SectionContentProps } from "../../types";
import FeaturesGrid from "./FeaturesGrid";
import FeaturesList from "./FeaturesList";
import FeaturesCards from "./FeaturesCards";
import FeaturesSection from "./FeaturesSection";
import { EducaeetCategoryGrid } from "../../educaeet";
import { HokCategories, HokFeatures } from "../../hok";
import OvanFeatures from "../../ovan/ovanfeatures/OvanFeatures";
import { SaasFeatures } from "../../saas";
import { CorporateFeatures } from "../../corporate";
import { AIFeatures } from "../../aistartup";
import { PortfolioGrid } from "../../portfolio";

// Re-export FeaturesSection for demo pages
export { default as FeaturesSection } from "./FeaturesSection";

export default function EditableFeaturesSection(props: SectionContentProps) {
    const { content, isSelected } = props;
    const variant = content?.variant || "grid";

    if (variant === 'saas') {
        return <SaasFeatures {...props} />;
    }
    if (variant === 'corporate') {
        return <CorporateFeatures {...props} />;
    }
    if (variant === 'aistartup') {
        return <AIFeatures {...props} />;
    }
    if (variant === 'portfolio') {
        return <PortfolioGrid {...props} />;
    }

    if (variant === 'ovan') {
        return <OvanFeatures {...props} />;
    }

    if (variant === 'hok-features') {
        return <HokFeatures {...props} />;
    }

    if (variant === 'hok') {
        return <HokCategories {...props} />;
    }

    if (variant === 'educaeet') {
        return <EducaeetCategoryGrid {...props} />;
    }

    return (
        <div className={`bg-white px-8 py-16 ${isSelected ? "ring-2 ring-blue-500" : ""}`}>
            {variant === 'list' || variant === 'v2' ? (
                <FeaturesList {...props} />
            ) : variant === 'cards' || variant === 'v3' ? (
                <FeaturesCards {...props} />
            ) : (
                <FeaturesGrid {...props} />
            )}
        </div>
    );
}
